import { CompanyAdmin } from 'core/application/adminDashboard/companySettings/admins/admins'
import removeAdmin, { DeleteCompanyAdmin } from 'core/application/adminDashboard/companySettings/admins/removeAdmin'

import Modal from 'common/components/feedback/Modal'
import notification from 'common/components/feedback/Notification'

import { commandRequest } from 'common/RequestUtils'

const handleRemove = async (translate: (key: string) => string, adminId: string, reload: () => void) => {
  const adminToRemove: DeleteCompanyAdmin = {
    id: adminId,
  }

  const deleteResponse = await commandRequest(() => removeAdmin(adminToRemove))
  if (deleteResponse.errors) {
    notification.open({
      message: deleteResponse.errors[0],
      type: 'error',
    })
  } else {
    notification.open({
      message: translate('admin-dashboard.company-settings.company-admins.remove-admin-success-message'),
      type: 'success',
    })
    reload()
  }
}

export const confirmRemoveAdmin = (translate: (key: string) => string, admin: CompanyAdmin, reload: () => void) => {
  return new Promise<void>((resolve) => {
    Modal.confirm({
      title: translate('admin-dashboard.company-settings.company-admins.remove-admin-confirm-title').replace(
        '[NAME]',
        admin.name,
      ),
      content: translate('admin-dashboard.company-settings.company-admins.remove-admin-confirm-content').replace(
        '[NAME]',
        admin.name,
      ),
      onOk: async () => {
        await handleRemove(translate, admin.id, reload)
        resolve()
      },
      okText: translate('admin-dashboard.company-settings.company-admins.remove-admin-confirm-button'),
      okType: 'default',
    })
  })
}
